// @flow

import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import localforage from 'localforage';
import Alert from 'react-s-alert';
import {Icon} from 'react-fa';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

import 'react-s-alert/dist/s-alert-default.css';

import theme from './theme.js';

import type {T_User} from './types.js';

import './css/Login.css';


type T_LoginProps = {
  on_checked: (user: T_User) => void,
  domain: string,
  height: number,
  width : number
};


type T_LoginState = {
  user   : string,
  pass   : string,
  disable: boolean
};



export default class Login extends Component<T_LoginProps, T_LoginState> {
  txt_pass: TextField;
  txt_user: TextField;
  quarter : number;
  multi_bg: boolean;
  
  set_last     : () => void;
  check        : () => void;
  keypress_user: (ev: SyntheticKeyboardEvent<*>) => void;
  keypress_pass: (ev: SyntheticKeyboardEvent<*>) => void;
  change_user  : (ev: SyntheticInputEvent<*>) => void;
  change_pass  : (ev: SyntheticInputEvent<*>) => void;
  
  
  
  constructor(props: T_LoginProps) {
    super(props);
    
    this.state = {
      user   : '',
      pass   : '',
      disable: true
    };
    
    this.multi_bg = false;
    
    this.set_last      = this.set_last.bind(this);
    this.check         = this.check.bind(this);
    this.keypress_user = this.keypress_user.bind(this);
    this.change_user   = this.change_user.bind(this);
    this.keypress_pass = this.keypress_pass.bind(this);
    this.change_pass   = this.change_pass.bind(this);
  }
  
  
  
  load_background(): void {
    this.quarter = this.multi_bg ? Math.floor(((new Date()).getMonth()) / 4) + 1 : 0;
    
    if (document.body) {
      document.body.style.background = `url(./img/fondo${this.quarter}.jpg) no-repeat 50% 50% fixed`;
      document.body.style.backgroundSize = '100% 100%';
    }
  }
  
  
  
  componentWillUnmount() {
    if (document.body) {
      document.body.style.backgroundImage = '';
    }
  }
  
  
  
  componentDidMount() {
    this.load_background();
    
    setTimeout(this.set_last, 500);
    
    window.history.replaceState(null, null, null);
  }
  
  
  
  set_last(): void {
    this.setState({disable: false});
    
    this.txt_user.focus();
    
    const last = window.location.href.indexOf('new_login') !== -1 ? 'testing_user' : 'last_user';
    
    localforage.getItem(last).then((res: ?string) => {
      if (res != null) {
        const [user, pass] = res.split(':');   // FIXME: PREGUNTA AL USUARIO SI QUIERE ALMACENAR SU PASSWORD.
        
        this.setState({user, pass});
      }
    });
  }
  
  
  
  check(): void {
    if (this.state.user && this.state.pass) {
      // NOTE: EL SERVICIO auth-user SOLO SIRVE PARA LA GDB. LA ANGÉLICA TIENE SU PROPIO SERVICIO DE AUTENTIFICACIÓN.
      // ESA ES LA RAZÓN DE QUE NO INCLUIMOS UN PARÁMETRO plataforma=gdb EN LA URL:
      
      const url = `https://${this.props.domain}/auth-user/?user=${this.state.user}&pass=${this.state.pass}`;
      
      fetch(url).then(resp => resp.json()).then((response: T_User | string) => {
        if (typeof response === 'string') {
          return Alert.error(`Error: ${response}`);
        }
        
        const user = (response: T_User);
        
        if (window.location.href.indexOf('new_login') !== -1) {
          localforage.setItem('testing_user', `${this.state.user}:${this.state.pass}`);
        }
        else {
          localforage.setItem('last_user', `${this.state.user}:${this.state.pass}`).then(() => {
            localforage.setItem('full_user', user);  // solo en este caso.
          });
        }
        
        this.props.on_checked(user);
      });
    }
  }
  
  
  
  keypress_user(ev: SyntheticKeyboardEvent<*>): void {
    if (ev.charCode === 13) {
      this.txt_pass.focus();
    }
  }
  
  
  
  change_user(ev: SyntheticInputEvent<*>): void {
    this.setState({user: ev.target.value});
  }
  
  
  
  keypress_pass(ev: SyntheticKeyboardEvent<*>): void {
    if (ev.charCode === 13) {
      this.check();
    }
  }
  
  
  
  change_pass(ev: SyntheticInputEvent<*>): void {
    this.setState({pass: ev.target.value});
  }
  
  
  
  render() {
    const lbc = {color: 'black', opacity: 0.6};
    
    return (
      <MuiThemeProvider muiTheme={theme('OpenSans')}>
        <div>
          <div className='welcome' style={{marginTop: Math.max(90, (this.props.height - 700)) / 2, left: (this.props.width - 700) / 2}}>
            <h3>Bienvenidos a la <span>nueva</span></h3>
            <h1>Geodatabase</h1>
          </div>
          
          <div className='Login' style={{marginTop: 20 + Math.max(200, (this.props.height - 400) / 2)}}>
            <Icon name='user' size='lg' />
            
            <TextField floatingLabelText='Nombre de usuario'
              disabled={this.state.disable}
              onKeyPress={this.keypress_user}
              onChange={this.change_user}
              floatingLabelShrinkStyle={lbc}
              value={this.state.user}
              ref={txt_user => this.txt_user = txt_user}
              className='login_user'
            />
            
            <br />
            
            <Icon name='lock' size='lg' />
            
            <TextField floatingLabelText='Clave'
              disabled={this.state.disable}
              onKeyPress={this.keypress_pass}
              onChange={this.change_pass}
              floatingLabelShrinkStyle={lbc}
              value={this.state.pass}
              type='password'
              ref={txt_pass => this.txt_pass = txt_pass}
              className='login_pass'
            />
              
            <br />
            
            <RaisedButton
              label='ENTRAR'
              primary={false}
              className='login_bt'
              onClick={this.check}
              buttonStyle={{backgroundColor: '#e4e4e4'}}
            />
            
            <div className='logo-agrosat'>
              <img src={'./img/logo_agrosat.png'} alt='logo' />
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Login.jsx